module.exports = __webpack_public_path__ + "img/vue2-corpsarr_noir.57f5ee61.png";